import { render, staticRenderFns } from "./Autenticate.vue?vue&type=template&id=4fc008e3&scoped=true&lang=pug&"
import script from "./Autenticate.vue?vue&type=script&lang=js&"
export * from "./Autenticate.vue?vue&type=script&lang=js&"
import style0 from "./Autenticate.vue?vue&type=style&index=0&id=4fc008e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc008e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fc008e3')) {
      api.createRecord('4fc008e3', component.options)
    } else {
      api.reload('4fc008e3', component.options)
    }
    module.hot.accept("./Autenticate.vue?vue&type=template&id=4fc008e3&scoped=true&lang=pug&", function () {
      api.rerender('4fc008e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/older_adult/Autenticate.vue"
export default component.exports